import { RangeSelection } from './range-selection.js';
import { RangeContent } from './range-content.js';
import { RangeCursor } from './range-cursor.js';


export function Range (pEditor)
{
  this.selection = new RangeSelection(pEditor, this);
  this.content = new RangeContent(pEditor, this);
  this.cursor = new RangeCursor(pEditor, this);

  let savedCurrentSelection =
      {
        anchorNode: null,
        anchorOffset: null,
        focusNode: null,
        focusOffset: null,
        isCollapsed: null,
        rangeCount: null,
        type: null
      },
      savedCurrentRange = null,
      savedCurrentBookmark =
      {
        startOffset: null,
        endOffset: null
      },
      checkSelectionTM = null;


  this.reInit = () =>
  {
    savedCurrentRange = null;
  };


  this.save = (isUnconditionally) =>
  {
    let isImageDelete = false;

    try
    {
      isImageDelete = (!pEditor.image.currentImage.parentNode || (!pEditor.image.currentImage.offsetWidth && !pEditor.image.currentImage.offsetHeight));
    }
    catch (e)
    {
      isImageDelete = true;
    }

    if (pEditor.isFocused)
    {
      pEditor.image.currentImage = pEditor.image.getCurrentImage();
    }

    if (pEditor.image.currentImage && !isImageDelete)
    {
      pEditor.image.saveCurrentImage = pEditor.image.currentImage;
    }
    else
    {
      if (pEditor.isFocused || BEditor.browser.isWebKit || isUnconditionally)
      {
        savedCurrentRange = this.getCurrent(true);
      }

      pEditor.image.currentImage = null;
      pEditor.image.saveCurrentImage = null;
    }
  };
  
  
  this.restore = (inCurrentImage, inCurrentRange, isDropdown) =>
  {
    if (!pEditor.isFocused)
    {
      return;
    }

    const localCurrentImage = inCurrentImage || pEditor.image.saveCurrentImage || null,
          localCurrentRange = inCurrentRange || savedCurrentRange || null;

    let imageObject;

    if (localCurrentImage)
    {
      if (localCurrentImage.parentNode)
      {
        pEditor.image.currentImage = localCurrentImage;

        if (pEditor.$Style(pEditor.image.currentImage, 'position').toLowerCase() === 'absolute')
        {
          pEditor.layer.objectFactory.selectNewElement(pEditor.image.currentImage);
        }
        else
        {
          imageObject = pEditor.image.objectFactory.getImageObject(pEditor.image.currentImage);

          if (imageObject)
          {
            imageObject.object.select(true);
          }
        }
      }
      else
      {
        this.setCursorPoint(pEditor.iFrameDoc.body, true);
      }

      pEditor.image.saveCurrentImage = null;
    }
    else if (localCurrentRange)
    {
      try
      {
        this.setSelect({startContainer: localCurrentRange.startContainer, startOffset: localCurrentRange.startOffset, endContainer: localCurrentRange.endContainer, endOffset: localCurrentRange.endOffset});
      }
      catch (err)
      {
        savedCurrentRange = null;
      }
    }

    this.save();
    this.saveBookmark();
  };
  
  
  this.getCurrent = (isUni, isDropdown) =>
  {
    let selectedRange = null,
        defaultRange = null,
        selection = this.selection.getCurrent(isUni);

    if (selection)
    {
      if (BEditor.browser.isIE && !isUni)
      {
        try
        {
          selectedRange = (selection) ? selection.createRange() : null;
        }
        catch (err)
        {
          return null;
        }

        return selectedRange;
      }
      else
      {
        if (selection.rangeCount > 0)
        {
          selectedRange = selection.getRangeAt(0);
          return selectedRange.cloneRange();
        }
        else if (pEditor.isFocused)
        {
          selection.removeAllRanges();
          defaultRange = pEditor.iFrameDoc.createRange();
          defaultRange.setStart(pEditor.iFrameDoc.body, 0);
          defaultRange.setEnd(pEditor.iFrameDoc.body, 0);
          selection.addRange(defaultRange);
          return defaultRange;
        }
        else
        {
          return null;
        }
      }
    }
    else if (pEditor.isFocused)
    {
      try
      {
        defaultRange = pEditor.iFrameDoc.createRange();
        defaultRange.setStart(pEditor.iFrameDoc.body, 0);
        defaultRange.setEnd(pEditor.iFrameDoc.body, 0);
        selection = pEditor.iFrame.getSelection();

        if (selection)
        {
          selection.removeAllRanges();
          selection.addRange(defaultRange);
        }
      }
      catch (err)
      {
        return null;
      }

      return defaultRange;
    }

    return null;
  };
  
  
  this.getPoints = () =>
  {
    let rangeStartContainer,
        rangeStartOffset,
        rangeEndContainer,
        rangeEndOffset,
        selection = this.selection.getCurrent(true),
        currentRange = this.getCurrent(true);

    if (selection && currentRange)
    {
      rangeStartContainer = currentRange.startContainer;
      rangeStartOffset = currentRange.startOffset;
      rangeEndContainer = currentRange.endContainer;
      rangeEndOffset = currentRange.endOffset;

      return (
      {
        'rangeObject': currentRange,
        'rangeStartContainer': rangeStartContainer,
        'rangeStartOffset': rangeStartOffset,
        'rangeEndContainer': rangeEndContainer,
        'rangeEndOffset': rangeEndOffset
      });
    }
  };


  this.getCurrentState = () =>
  {
    this.save();
    pEditor.font.color.getCurrentForeColor();
    pEditor.font.background.getCurrentBackColor();
    pEditor.link.remover.queryRemoveLinkEnabled();
  };

  
  this.setCursorPoint = (element, pointPos, currentSelection, currentRange) =>
  {
    if (!pEditor.isFocused)
    {
      return;
    }

    if (BEditor.browser.isIE && (currentSelection || currentRange))
    {
      currentRange = currentRange || pEditor.iFrameDoc.body.createTextRange();
      currentRange.moveToElementText(element);

      if (pointPos != null)
      {
        currentRange.collapse(pointPos);
      }

      currentRange.select();
    }
    else
    {
      if (!currentSelection)
      {
        currentSelection = this.selection.getCurrent(true);
        currentSelection.selectAllChildren(pEditor.iFrameDoc.body);
      }

      currentSelection.removeAllRanges();
      currentRange = currentRange || pEditor.iFrameDoc.createRange();

      if (element.childNodes.length > 0)
      {
        currentRange.selectNodeContents(element);
      }
      else
      {
        currentRange.selectNode(element);
      }

      if (pointPos != null)
      {
        currentRange.collapse(pointPos);
      }

      currentSelection.addRange(currentRange);
    }

    this.save(true);
  };


  this.normalizeCursor = () =>
  {
    const currentRange = this.getCurrent(true);

    if (currentRange)
    {
      if (currentRange.collapsed)
      {
        if (currentRange.startContainer.nodeName === 'BODY')
        {
          if (currentRange.startOffset === 0)
          {
            if (pEditor.iFrameDoc.body.firstChild && pEditor.iFrameDoc.body.firstChild.nodeName === 'P')
            {
              this.setCursorPoint(pEditor.iFrameDoc.body.firstElementChild, true);
            }
          }
        }
      }
    }
  };


  this.startCheckSelection = () =>
  {
    if (checkSelectionTM) clearInterval(checkSelectionTM);
    checkSelectionTM = setInterval(this.checkSelection, 137);
  };


  this.stopCheckSelection = () =>
  {
    if (checkSelectionTM) clearInterval(checkSelectionTM);
  };


  this.checkSelection = () =>
  {
    let currentSelection = this.selection.getCurrent(true);

    if (currentSelection && currentSelection.type !== 'None' && currentSelection.anchorNode && currentSelection.focusNode)
    {
      if (!(savedCurrentSelection.anchorNode && currentSelection.anchorNode.isSameNode(savedCurrentSelection.anchorNode) &&
            currentSelection.anchorOffset === savedCurrentSelection.anchorOffset &&
            savedCurrentSelection.focusNode && currentSelection.focusNode.isSameNode(savedCurrentSelection.focusNode) &&
            currentSelection.focusOffset === savedCurrentSelection.focusOffset &&
            currentSelection.isCollapsed === savedCurrentSelection.isCollapsed &&
            currentSelection.rangeCount === savedCurrentSelection.rangeCount &&
            currentSelection.type === savedCurrentSelection.type))
      {
        savedCurrentSelection.anchorNode = currentSelection.anchorNode;
        savedCurrentSelection.anchorOffset = currentSelection.anchorOffset;
        savedCurrentSelection.focusNode = currentSelection.focusNode;
        savedCurrentSelection.focusOffset = currentSelection.focusOffset;
        savedCurrentSelection.isCollapsed = currentSelection.isCollapsed;
        savedCurrentSelection.rangeCount = currentSelection.rangeCount;
        savedCurrentSelection.type = currentSelection.type;

        this.saveBookmark();
      }
    }
    else if (currentSelection.type === 'None')
    {
      savedCurrentSelection.anchorNode = currentSelection.anchorNode;
      savedCurrentSelection.anchorOffset = currentSelection.anchorOffset;
      savedCurrentSelection.focusNode = currentSelection.focusNode;
      savedCurrentSelection.focusOffset = currentSelection.focusOffset;
      savedCurrentSelection.isCollapsed = currentSelection.isCollapsed;
      savedCurrentSelection.rangeCount = currentSelection.rangeCount;
      savedCurrentSelection.type = currentSelection.type;

      this.clearBookmark();
    }
  };


  this.saveBookmark = () =>
  {
    if (!pEditor.isFocused)
    {
      return;
    }

    const getNodeTextLength = (node) =>
    {
      let textLength = 0;

      if (node.nodeType === 1)
      {
        for (let i = 0; i < node.childNodes.length; i++)
        {
          if (node.childNodes[i].nodeType === 1)
          {
            textLength += getNodeTextLength(node.childNodes[i]);
          }
          else if (node.childNodes[i].nodeType === 3)
          {
            textLength += node.childNodes[i].textContent.length;
          }
        }
      }
      else if (node.nodeType === 3)
      {
        textLength = node.textContent.length;
      }

      return textLength;
    };

    const getOffset = (node) =>
    {
      let prevSibling,
          offset = 0;

      do
      {
        prevSibling = node.previousSibling;

        while (prevSibling)
        {
          offset += getNodeTextLength(prevSibling);
          prevSibling = prevSibling.previousSibling;
        }

        node = node.parentNode;
      }
      while (node && node.nodeName !== 'BODY');

      return offset;
    };

    let points = this.getPoints();

    this.clearBookmark();

    if (points && points.rangeObject)
    {
      if (points.rangeStartContainer.nodeType === 3 && points.rangeEndContainer.nodeType === 3)
      {
        savedCurrentBookmark.startOffset = points.rangeStartOffset + getOffset(points.rangeStartContainer);
        savedCurrentBookmark.endOffset = points.rangeEndOffset + getOffset(points.rangeEndContainer);
      }
    }
  };


  this.restoreBookmark = () =>
  {
    if (!pEditor.isFocused)
    {
      return;
    }

    const findPoint = (node, offset, targetOffset, isStartPoint) =>
    {
      let targetNode;

      while (node)
      {
        if (node.nodeType === 1)
        {
          if (node.childNodes.length > 0)
          {
            [targetNode, offset] = findPoint(node.childNodes[0], offset, targetOffset, isStartPoint);

            if (targetNode)
            {
              return [targetNode, offset];
            }
          }
        }
        else if (node.nodeType === 3)
        {
          offset += node.textContent.length;

          if (offset >= targetOffset)
          {
            if (isStartPoint && offset === targetOffset)
            {
              node = pEditor.helpers.element.getNextTextNode(node, node.nextSibling) || node;
            }

            return [node, offset];
          }
        }

        node = node.nextSibling;
      }

      return [null, offset];
    };

    if (savedCurrentBookmark.startOffset !== null && savedCurrentBookmark.endOffset !== null)
    {
      let [startPointNode, startPointOffset] = findPoint(pEditor.iFrameDoc.body.childNodes[0], 0, savedCurrentBookmark.startOffset, true);

      if (savedCurrentBookmark.startOffset === savedCurrentBookmark.endOffset)
      {
        if (startPointNode)
        {
          let offset = (startPointOffset === savedCurrentBookmark.startOffset) ? 0 : savedCurrentBookmark.startOffset - (startPointOffset - startPointNode.textContent.length);

          this.setSelect(
            {
              startContainer: startPointNode,
              startOffset: offset,
              endContainer: startPointNode,
              endOffset: offset
            });
        }
      }
      else
      {
        let [endPointNode, endPointOffset] = findPoint(pEditor.iFrameDoc.body.childNodes[0], 0, savedCurrentBookmark.endOffset, false);

        if (startPointNode && endPointNode)
        {
          this.setSelect(
            {
              startContainer: startPointNode,
              startOffset: (startPointOffset === savedCurrentBookmark.startOffset) ? 0 : savedCurrentBookmark.startOffset - (startPointOffset - startPointNode.textContent.length),
              endContainer: endPointNode,
              endOffset: savedCurrentBookmark.endOffset - (endPointOffset - endPointNode.textContent.length)
            });
        }
      }
    }

    this.save();
    this.saveBookmark();
    this.startCheckSelection();
  };


  this.clearBookmark = () =>
  {
    if (!pEditor.isFocused)
    {
      return;
    }

    savedCurrentBookmark.startOffset = null;
    savedCurrentBookmark.endOffset = null;
  };


  const setSelectDo = (selectPoints) =>
  {
    if (!pEditor.isFocused)
    {
      return;
    }

    let selection = pEditor.iFrame.getSelection();
    selection.removeAllRanges();
    let currentRange = pEditor.iFrameDoc.createRange();
    currentRange.setStart(selectPoints.startContainer, selectPoints.startOffset);
    currentRange.setEnd(selectPoints.endContainer, selectPoints.endOffset);
    selection.addRange(currentRange);
  };


  this.setSelect = (selectPoints) =>
  {
    if (selectPoints.startContainer != null && selectPoints.endContainer != null)
    {
      if (BEditor.browser.isEdge && selectPoints.startContainer.isSameNode(selectPoints.endContainer) &&
        selectPoints.startContainer.nodeType === 3 && selectPoints.startContainer.length > 0 &&
        selectPoints.startOffset === 0 && selectPoints.endOffset === 0)
      {
        setSelectDo(
          {
            startContainer: selectPoints.startContainer,
            startOffset: 1,
            endContainer: selectPoints.endContainer,
            endOffset: 1
          });
      }

      setSelectDo(selectPoints);
    }
  };
}